"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.range = void 0;

function range(a, b, c) {
  if (c === void 0) {
    c = 1;
  }

  return Array.from(Array(b ? Math.floor((b - a) / c) : a), function (v, i) {
    return b ? a + i * c : i;
  });
}

exports.range = range;